
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';


type LinkProps = {
    underline?: string,
}

export default function Link({to, children, ...props}: LinkProps & RouterLinkProps) {
    //    children = React.cloneElement(children as React.ReactElement<any>, props)

    return <RouterLink
               className={props?.underline ? "underline-" + props?.underline   : ""}
               to={to}>
               {children}
           </RouterLink>
    // return <JoyLink
    //            component={RouterLink}
    //            {...props}
    //            to={to}>

    //            {children}

    //        </JoyLink>;
}



export function TextLink({to, children, ...props}: LinkProps & RouterLinkProps) {
    return <Link underline="hover" to={to} {...props}>
               { children }
           </Link>

}
